import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Reveal } from "@/components/motion";

// Reusable cinematic hero for inner pages, with parallax background
export default function PageHero({ image, overline, titleLines = [], subtitle }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);

  return (
    <section
      ref={ref}
      data-testid="page-hero"
      className="relative flex min-h-[58vh] items-end overflow-hidden bg-cab-deep pt-20 md:min-h-[66vh]"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0 will-change-transform">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </motion.div>
      <div className="absolute inset-0 bg-hero-scrim" />
      <div className="absolute inset-0 grain" />

      <div className="relative mx-auto w-full max-w-[1400px] px-5 pb-14 md:px-8 md:pb-24">
        {overline && (
          <Reveal>
            <div className="mb-6 flex items-center gap-3">
              <span className="h-px w-12 bg-cream/50" />
              <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-cream/80">
                {overline}
              </span>
            </div>
          </Reveal>
        )}
        <h1 className="font-display text-[13vw] font-extrabold uppercase leading-[0.9] tracking-tighter text-cream sm:text-7xl lg:text-8xl">
          <MaskLines lines={titleLines} delay={0.15} />
        </h1>
        {subtitle && (
          <Reveal delay={0.4}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-cream/80 md:text-lg">
              {subtitle}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
